import React from "react";
import axios from "axios";
import constant from "../../constant";

export default class CitylistComp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      city_list: null,
      country_id: 0,
      city_id: 0
    };
  }

  componentDidMount() {
    this.initiate();
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    if (newProps.country_id !== this.props.country_id) {
      this.fetch_cities(newProps.country_id, newProps.city_id);
    }
  }

  initiate = () => {
    let country_id = this.state.country_id;
    if (this.props.city_id !== "") {
      country_id = this.props.country_id;
    }
    this.fetch_cities(country_id, this.props.city_id);
  };

  fetch_cities = (country_id, city_id) => {
    axios
      .get(`${constant.phpHost}action/listing.php`, {
        params: {
          todo: "get_city_list",
          country_id: country_id
        }
      })
      .then(res => {
        this.setState({
          city_list: res.data ? res.data : null,
          city_id: city_id
        });
      });
  };

  select_city = e => {
    this.props.handleCity(e.target.value);
  };

  render() {
    let { city_list } = this.state;
    return (
      <select
        name="city_id"
        onChange={this.select_city}
        value={this.props.city_id}
        required
      >
        <option value="0">Select City</option>

        {city_list &&
          city_list.map((city, i) => (
            <option key={i} value={city.id}>
              {city.name}
            </option>
          ))}
      </select>
    );
  }
}
